<span class="d-flex align-items-center" (click)="onResetFacets()">
  <ng-container *ngIf="showIconRight; else templateIconLeft">
    {{ 'catalog.resetFilters_action' | cxTranslate }}
    <i nz-icon pyIconThemeReverse class="ml-3" nzType="close-circle" nzTheme="outline"></i>
  </ng-container>

  <ng-template #templateIconLeft>
    <i nz-icon pyIconThemeReverse class="mr-3" nzType="close-circle" nzTheme="outline"></i>
    {{ 'catalog.resetFilters_action' | cxTranslate }}
  </ng-template>
</span>
